function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import { reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import { InputContainer } from './style';
import { RadioButton } from '../../../../../atoms/Input/Radio';
import Label from '../../../../../atoms/Label';

var RBF =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RBF, _React$Component);

  function RBF(props) {
    var _this;

    _classCallCheck(this, RBF);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RBF).call(this, props));

    _this.handleOptionChange = function (changeEvent) {
      _this.props.handleClick(changeEvent.target.value);

      _this.setState({
        selectedOption: changeEvent.target.value
      });
    };

    _this.state = {
      selectedOption: _this.props.default
    };
    return _this;
  }

  _createClass(RBF, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      // data es un array de posibles datas [year, day, month]
      if (this.props.data.length === 1) return React.createElement("form", null, this.props.data.map(function (a) {
        return React.createElement(InputContainer, {
          key: a
        }, React.createElement(Label, {
          tag: a
        }));
      }));
      if (this.props.data) return React.createElement("form", null, this.props.data.map(function (a) {
        return React.createElement(InputContainer, {
          key: a
        }, React.createElement(RadioButton, {
          type: "radio",
          value: a,
          disabled: _this2.props.disabled,
          onChange: _this2.handleOptionChange,
          checked: _this2.state.selectedOption === a
        }), React.createElement(Label, {
          tag: a
        }));
      }));
      return '';
    }
  }]);

  return RBF;
}(React.Component);

RBF.propTypes = {
  data: PropTypes.array.isRequired,
  disabled: PropTypes.bool.isRequired,
  default: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired
};
var RadioButtonForm = reduxForm({
  form: 'RadioButtonForm',
  shouldAsyncValidate: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})(RBF);
export default RadioButtonForm;